import HeroImg from "../assets/img/pictures/service.jpg";
import CustomsImg from "../assets/img/pictures/customs.jpg";
import DangerImg from "../assets/img/pictures/dangerousGood.jpg";
import TruckImg from "../assets/img/pictures/landtruck.jpg";
import SeaImg from "../assets/img/pictures/sea.jpg";
import AirCraftImg from "../assets/img/pictures/servicesimage.jpg";
import WareImg from "../assets/img/pictures/warehouseServ.jpg";
import CargoIco from "../assets/img/icon/cargo-ship.png";
import PlaneIco from "../assets/img/icon/Icon-plane.png";
import WarehouseIco from "../assets/img/icon/Icon-home.png";
import ClearIco from "../assets/img/icon/clearance.png";
import DangerIco from "../assets/img/icon/toxic.png";
import ServShape from '../assets/img/shape/service-shape.png';
import PickupIco from "../assets/img/icon/icon-service-3.png";
import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from "react-router-dom";

export default function Services() {
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <>
      <div
        class="site-breadcrumb"
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div class="container">
          <div class="site-breadcrumb-wpr">
            <h2 class="breadcrumb-title">Our Services</h2>
            <ul class="breadcrumb-menu clearfix">
              <li>
              <Link to="/">Home</Link>
              </li>
              <li class="active">Our Services</li>
            </ul>
            <p style={{ color: "#FFF" }}>
              At Hallgord Shipping, we offer a comprehensive range of cargo and
              logistics services to meet your transportation needs. With years
              of experience in the industry, we ensure efficient and reliable
              solutions for your goods and cargo. Our team of dedicated
              professionals is committed to delivering top-notch services that
              exceed your expectations. Whether you need air freight, sea
              freight, land transportation, or warehousing services, we have you
              covered.
            </p>
          </div>
        </div>
      </div>
      <div class="service-area-2 bg-2 de-padding pos-rel">
        <img
          src={ServShape}
          class="service-shape-2"
          alt="no image"
        />
        <div class="container" 
        data-aos="zoom-in-up"
        data-aos-easing="ease-in-sine"
        data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="500">
          <div class="service-wpr-2 grid-3">
            <div class="service-box-2" style={{paddingBottom: '60px'}} >
              <div class="service-pic-2" >
                <img
                  src={AirCraftImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img src={PlaneIco} alt="no image" />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Aircraft Charter Services</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      When time is of the essence, our aircraft charter services
                      offer a swift and tailored solution. Whether for urgent
                      shipments or specialized cargo, our network of charter
                      aircraft ensures that your goods reach their destination
                      promptly, without compromise.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="service-box-2" style={{paddingBottom: '60px'}}>
              <div class="service-pic-2">
                <img
                  src={DangerImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img
                          src={DangerIco}
                          alt="no image"
                          style={{
                            width: "70px",
                            filter: `invert(${isHovered ? 1 : 0})`,
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Dangerous Good Handling</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      Transporting hazardous materials requires specialized
                      expertise and strict adherence to safety regulations. Our
                      dangerous goods handling service ensures that your
                      hazardous cargo is managed with the highest level of care
                      and compliance, safeguarding both people and the
                      environment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="service-box-2" style={{paddingBottom: '60px'}}>
              <div class="service-pic-2">
                <img
                  src={WareImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img src={WarehouseIco} alt="no image" />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Warehouse Facility</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      Our state-of-the-art warehouse facility provides secure
                      and efficient storage solutions for your goods. Whether
                      short-term or long-term, we offer flexible storage options
                      that help you manage your inventory effectively. Our
                      meticulous inventory management ensures that your goods
                      are always ready for distribution.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="service-box-2" style={{paddingBottom: '60px'}}>
              <div class="service-pic-2">
                <img
                  src={CustomsImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img
                          src={ClearIco}
                          alt="no image"
                          style={{ width: "70px" }}
                        />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Custom Clearance</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      Navigating the complexities of customs regulations can be
                      a daunting task. Our custom clearance service ensures that
                      your goods pass through customs seamlessly. With a deep
                      understanding of local and international regulations, we
                      expedite the clearance process, saving you time and
                      minimizing delays.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="service-box-2" style={{paddingBottom: '60px'}}>
              <div class="service-pic-2">
                <img
                  src={SeaImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img src={CargoIco} alt="no image" />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Sea Forwarding</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      As a gateway to global trade, sea freight plays a pivotal
                      role in the supply chain. Our sea forwarding service
                      connects you to international markets with reliability and
                      efficiency. With a network of carriers and a commitment to
                      on-time deliveries, we ensure that your cargo sails
                      smoothly across the seas.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="service-box-2" style={{paddingBottom: '60px'}}>
              <div class="service-pic-2">
                <img
                  src={TruckImg}
                  alt="no image"
                  style={{ height: "250px", width: "450px" }}
                />
                <div class="service-desc-2">
                  <div class="service-icon-title">
                    <div class="service-icon-2">
                      <i>
                        <img
                          src={PickupIco}
                          alt="no image"
                          style={{ width: "70px" }}
                        />
                      </i>
                    </div>
                    <div class="service-title-2">
                      <h5 class="heading-5 mb-0">Land Freight Forwarding</h5>
                    </div>
                  </div>
                  <div class="service-text">
                    <p>
                      Efficient land transportation is the backbone of domestic
                      and regional trade. Our land freight forwarding service
                      provides seamless connectivity, optimizing routes and
                      ensuring timely deliveries. We handle the logistics, so
                      you can focus on growing your business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
